module.exports = __webpack_public_path__ + "media/images/application/bg-d88bcfa38144c1525735066ba38d0b38.jpg";